module.exports = __webpack_public_path__ + "static/img/pic1.76fc44c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example01/pic1.png
// module id = a9gX
// module chunks = 1